import { userModel } from 'entities/user';
import { all, call, put, select, takeLatest } from 'typed-redux-saga';
import { userActions } from '../reducer';
import { ContractsNames, ContractsService, request, success, error } from '../../../../shared';
import { getTokenBalanceSaga } from './getTokenBalance';

export function* getBuyInfoSaga({ type, payload: { web3Provider } }: ReturnType<typeof userActions.getBuyInfo>) {
  try {
    yield put(request(type));

    const { chainType, network } = yield select(userModel.selectors.selectUserWeb3Info);
    const { address: udstAddress } = ContractsService.getContractData(ContractsNames.USDTToken, network, chainType);
    const { address: starsV2Address } = ContractsService.getContractData(ContractsNames.StarsV2, network, chainType);

    const { address: buyAddress } = ContractsService.getContractData(ContractsNames.MogulBuy, network, chainType);

    const contractsService = new ContractsService(web3Provider);
    const starsV2Contract = contractsService.getErc20Contract(starsV2Address);
    const buyContract = contractsService.getBuyContract(buyAddress);

    yield all([
      call(getTokenBalanceSaga, {
        type: userActions.getTokenBalance.type,
        payload: {
          tokenAddress: starsV2Address,
          isNativeCurrency: false,
          web3Provider,
        },
      }),
      call(getTokenBalanceSaga, {
        type: userActions.getTokenBalance.type,
        payload: {
          tokenAddress: udstAddress,
          isNative: false,
          web3Provider,
        },
      }),
      call(getTokenBalanceSaga, {
        type: userActions.getTokenBalance.type,
        payload: {
          tokenAddress: '',
          isNativeCurrency: true,
          web3Provider,
        },
      }),
    ]);

    const [price, nativePrice, startV2BuyContractBalance] = yield* all([
      call(buyContract.methods.price().call),
      call(buyContract.methods.nativePrice().call),
      call(starsV2Contract.methods.balanceOf(buyAddress).call),
    ]);

    yield put(
      userActions.updateBuyInfo({
        price,
        nativePrice,
        tokensLeftOnContract: startV2BuyContractBalance,
      } as { price: string; nativePrice: string; tokensLeftOnContract: string }),
    );

    yield put(success(type));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    yield put(error(type));
  }
}

export default function* listener() {
  yield takeLatest(userActions.getBuyInfo.type, getBuyInfoSaga);
}
